import { CSSObject } from "@emotion/react";
import { type AngelouCSS, type ButtonStyleOverrides } from "@newsela/angelou";

export const footerButtonsCss: CSSObject = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const buttonCss: Partial<ButtonStyleOverrides<AngelouCSS>> = {
  root: {
    margin: "0 6px",
    padding: "16px",

    "&:last-of-type": {
      marginRight: "12px",
    },
  },
};

export const primaryButtonsContainerCSS: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "auto",
};
